import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum ConnectionSearchInteractionOption {
  All = "all",
  AppUsed = "app_used",
  ConnectionStatus = "connection_status",
  Everyone = "everyone",
  Keyword = "keyword",
  Managed = "managed",
  OwnedByMe = "owned_by_me",
  Owner = "owner",
  Private = "private",
  PublicId = "public_id",
  SharedByMe = "shared_by_me",
  SharedWithMe = "shared_with_me",
}

export function useEmitConnectionSearchInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: ConnectionSearchInteractionOption) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ConnectionSearch,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
